import {memoize} from '@servicenow/ui-internal';
import {PROPERTY_DEFS} from '../symbols';
import filterPropertyDefinitions from './filterPropertyDefinitions';
import getHostVariables from './getHostVariables';

const filterComputedProperties = memoize(
	host => {
		const hostVariables = getHostVariables(host);
		return filterPropertyDefinitions(hostVariables[PROPERTY_DEFS], d => d.computed);
	},
	{createCacheKey: host => host.tagName, profileName: 'filterComputedProperties'}
);

export default filterComputedProperties;
